import ABaseComponent from '../../../ABaseComponent';
import * as echarts from 'echarts/core';
import Style from  './lineChart.css'
import {  TitleComponent, GridComponent  , ToolboxComponent,TooltipComponent,} from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
echarts.use([TitleComponent,GridComponent, ToolboxComponent,TooltipComponent, LineChart, CanvasRenderer, UniversalTransition]);

export default class EChart extends ABaseComponent {
    constructor(props) {
        super(props)
        this.style = {
            width: "100%",
            height: "100%"
        }
        this.text= this.props.text
        this.subtext= this.props.subtext
        this.chart = null
        this.resetChart = this.resetChart.bind(this)
    }
    componentDidMount() {
        // 基于准备好的dom，初始化echarts实例
        super.componentDidMount(this);
        var _this=this
        this.chart = echarts.init(document.getElementById(this.props.id));
        let data = new Array(61)
        data.fill(0)
        // 绘制图表
        this.chart.setOption({
            tooltip: {
                trigger: 'axis',
                position: function (pt) {
                  return [pt[0], '10%'];
                },
                formatter:function (data, index) {
                    if(_this.props.formatter){
                        return _this.props.formatter(value, index)
                    }
                    return data[0].value + '%';
                },
                backgroundColor:"rgba(21, 163, 242, 0.41)",
                textStyle:{
                    fontSize: 12,
                    fontFamily: 'Myriad Pro',
                    fontWeight: 400,
                    color:"#fff"
                },
                borderColor:'rgba(21, 163, 242, 0.41)',
                padding:[5,10,5,10],
              },
            // title:[{
            //     text:this.text ,                
            //     left: "left",
            //     top: "2%",
            //     textStyle:{
            //         color:"",
            //         fontFamily:"Microsoft YaHei",
            //         fontSize:14,
            //         fontWeight:400
            //     }
            // }, {
            //     text: this.subtext,    
            //     left: "right",
            //     top: "2%"
            // }],
            animation: false,
            grid: {
                show: true,
                z: 2,
                left: "0",
                top: "0",
                width: "100%",
                height: "100%",
                containLabel: true,
                backgroundColor: "transparent",
                borderColor: "none"
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                axisLabel: {
                    rotate: 0,
                    color:"#E8F6F8",
                    fontSize:14,
                    fontWeight:400,
                    fontFamily:"Microsoft YaHei",
                    interval: (index, value) => {

                        return value === "0" || value === "60"
                    },
                    show: false
                },

                axisLine: {
                    lineStyle: {
                        color: "red"
                    },
                    
                },
                scale: false,
                splitLine: {
                    show:false
                },
                axisTick: {
                    show: false
                },
                data: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "60"].reverse()
            },
            yAxis: {
                show: false,
                position: "right",
                scale: false,
                max: this.props.max?parseInt(this.props.max):100,
                min: 0,
                splitNumber: 5,
                type: "value",
                name: "",
                axisLabel: {
                    formatter: function (value, index) {
                        if(_this.props.formatter){
                            return _this.props.formatter(value, index)
                        }
                        return value + '%';
                    },
                    show: false
                },
                axisLine: {
                    show: false,
                    lineStyle: {
                        color: "rgb(17,125,187)"
                    }
                },
                gridIndex: 0,
                splitLine: {
                    show: false
                },
                axisTick: {
                    show: false
                }
            },
            axisPointer:{
                lineStyle:{
                    color:"#00B4FF",
                    type:"solid"
                }
            },
            series: {
                type: "line",
                name: "使用率",
                data: data,
                // smooth: true,
                showSymbol: false,
                symbol: 'circle',
                symbolSize:5,
                emphasis:{
                    areaStyle: {
                        normal: {
                            color: "rgba(19, 157, 245, 0.2)"
                        }
                    },
                    
                    itemStyle: {
                        normal: {
                            color: '#0EDEFF',
                           
    
                        }
                    },
                    lineStyle: {
                        normal: {
                            color: "#139DF5",
                            width: 2
                        }
                    },
                },
                areaStyle: {
                    normal: {
                        color: "rgba(19, 157, 245, 0.2)"
                    }
                },
                
                itemStyle: {
                    normal: {
                        color: '#0EDEFF',
                       

                    }
                },
                lineStyle: {
                    normal: {
                        color: "#139DF5",
                        width: 2
                    }
                },
                selected:{
                    selectedMode:'single'
                },
                xAxisIndex: 0,
                yAxisIndex: 0
            }          
        });
    }

    upData = data => {
        var _option = this.chart.getOption();
        var json = {};
        json.series = [];
        var item = {};

        item.data = _option.series[0].data;
        item.data = data;
        json.series = item;

        this.chart.setOption(json);
    }

    addData = data => {
        var _option = this.chart.getOption();
        var json = {};
        json.series = [];
        var item = {};

        item.data = _option.series[0].data;
        item.data.shift();
        item.data.push(data);
        json.series = item;

        this.chart.setOption(json);
    }
    changeTitle = (data) =>{
        this.setState({text:data.text})
        this.setState({subtext:data.subtext})
    }
    changeTotal = (data) =>{
        this.setState(data)
    }
    resetChart = () =>{
        let data = new Array(61)
        data.fill(0)
        this.upData(data)
        this.setState({total:"",used:"",ret:""})
    }
    createContent() {
        console.log("组件渲染---------------");
        const id = this.props.id;
        let style={...this.style}
        return (
            
            <div style={{}} style={style}>
                <div  style={{width:'100%',height:40}}><span className={Style.lineTitle} style={{float:"left"}}>{this.state.text}</span><span className={Style.linesubTitle} style={{float:"right"}}>{this.state.subtext}</span></div>
                <div className={Style.hkchart} style={this.style} id={id} data-type="area2d" chart-type="Area" ref="Echart"
                    data-url={this.props["data-url"]}>
                </div>
                <div  style={{height:20,width:"100%",position:"relative"}}>
                    <span className={Style.lineAxi} style={{float:"left"}}>60S</span>
                    <div className={Style.lineTotal} style={{width:417,display:this.state.showTotal?"block":"none"}}><span style={{width:139,display:"inline-block"}}>总量：{this.state.total}</span><span style={{width:139,display:"inline-block"}}>已用：{this.state.used}</span><span style={{width:139,display:"inline-block"}}>剩余：{this.state.ret}</span></div>
                    <span className={Style.lineAxi} style={{float:"right"}}>0S</span>
                </div>
            </div>)
    }
}